"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseCategories = void 0;
/**
 * Utility to filter categories with thruthy data and map them to `CategoryBoxProps` type.
 * @returns Categories with thruthy data
 */
const parseCategories = ({
  categories
}) => (categories ?? []).filter(category => !!category).filter(({
  link,
  themeTag,
  thumbnailUrl
}) => !!link?.relativeUrl && !!themeTag && !!thumbnailUrl).map(({
  link,
  themeTag,
  thumbnailUrl
}) => ({
  imageUrl: thumbnailUrl,
  relativeUrl: link?.relativeUrl ?? '',
  title: themeTag
}));
exports.parseCategories = parseCategories;
